export const project = 'tagginghyundai'; // need this for when we dynamically import utils

const compositeTypeMapping = {
	certified: 'CPO',
	new: 'new',
	used: 'used'
};

const convertToNumber = (value) => {
	let num;

	if (value) {
		// Remove any non-numeric characters except for the decimal point
		const numericValue = value.replace(/[^0-9.]/g, '');
		// Convert the cleaned string to a number
		num = parseFloat(numericValue);
	}

	return num;
};

const hasHsuVehicles = (vehicles) => {
	return vehicles?.some?.((vehicle) => {
		return vehicle.classification === 'classifieds';
	});
};

export const getCategoryForPageView = ({ window: win }) => {
	let categoryForPageView;

	if (
		win?.DDC?.dataLayer?.page?.pageInfo?.isVlp ||
		win?.DDC?.dataLayer?.page?.pageInfo?.isVdp
	) {
		const [category] =
			win?.DDC?.dataLayer?.page?.pageInfo?.pageName
				?.toLowerCase?.()
				.match(/new|used|certified/) || [];
		categoryForPageView = compositeTypeMapping[category];

		if (win?.DDC?.dataLayer?.page?.pageInfo?.isVlp) {
			categoryForPageView = hasHsuVehicles(win?.DDC?.dataLayer?.vehicles)
				? `${categoryForPageView},hsu`
				: categoryForPageView;
		} else if (win?.DDC?.dataLayer?.page?.pageInfo?.isVdp) {
			categoryForPageView = hasHsuVehicles(win?.DDC?.dataLayer?.vehicles)
				? 'hsu'
				: categoryForPageView;
		}
	}

	return categoryForPageView;
};

export const getPageType = ({ window: win }) => {
	let pageType;

	if (
		win?.DDC?.dataLayer?.page?.pageInfo?.isVdp &&
		hasHsuVehicles(win?.DDC?.dataLayer?.vehicles)
	) {
		pageType = 'vdp_hsu';
	}

	return pageType;
};

const determineFuelType = (vehicle) => {
	if (
		['plug-in hybrid', 'plug in hybrid', 'phev'].some((ft) =>
			(vehicle?.normalFuelType || vehicle?.fuelType)
				?.toLowerCase()
				?.includes(ft)
		)
	) {
		return 'phev';
	} else if (
		['hybrid', 'hev'].some((ft) =>
			(vehicle?.normalFuelType || vehicle?.fuelType)
				?.toLowerCase()
				?.includes(ft)
		)
	) {
		return 'hev';
	} else if (
		['fuel cell', 'hydrogen'].some((ft) =>
			(vehicle?.normalFuelType || vehicle?.fuelType)
				?.toLowerCase()
				?.includes(ft)
		)
	) {
		return 'fuel cell';
	} else if (
		['electric', 'bev', 'ev'].some((ft) =>
			(vehicle?.normalFuelType || vehicle?.fuelType)
				?.toLowerCase()
				?.includes(ft)
		)
	) {
		return 'ev';
	} else if (
		['gasoline', 'regular unleaded', 'premium unleaded'].some((ft) =>
			(vehicle?.normalFuelType || vehicle?.fuelType)
				?.toLowerCase()
				?.includes(ft)
		)
	) {
		return 'gas';
	}
	return undefined;
};

export const getFuelType = ({ vehicles = [] }) => {
	if (vehicles.length === 1) {
		return determineFuelType(vehicles[0]);
	}
	return null;
};

const getDiscount = (vehicle) => {
	const msrp = vehicle?.pricing?.msrp || vehicle?.msrp;
	const internetPrice =
		vehicle?.pricing?.internetPrice || vehicle?.internetPrice;

	let discount;

	if (msrp && internetPrice) {
		discount = convertToNumber(msrp) - convertToNumber(internetPrice);
	}

	// no negative discounts, probably means msrp was zero
	if (discount && discount < 0) {
		discount = undefined;
	}

	return discount;
};

export const getVehicleImpressions = ({ vehicles = [] }) =>
	vehicles.map((vehicle, index) => ({
		item_id: vehicle.vin,
		item_name: vehicle.model,
		price:
			convertToNumber(vehicle?.pricing?.internetPrice) ||
			convertToNumber(vehicle?.internetPrice) ||
			0,
		msrp:
			convertToNumber(vehicle?.pricing?.msrp) ||
			convertToNumber(vehicle?.msrp) ||
			0,
		discount: getDiscount(vehicle) || '{{UNDEFINED}}',
		rebate: undefined,
		item_brand: vehicle.make,
		item_category: hasHsuVehicles([vehicle])
			? 'hsu'
			: vehicle.inventoryType,
		item_category2: vehicle.year,
		item_category3: vehicle.exteriorColor,
		item_category4: determineFuelType(vehicle),
		item_category5: '{{UNDEFINED}}', // package, we don't easily have this
		item_variant: vehicle.trim,
		item_type: vehicle.bodyStyle,
		...(vehicles.length > 1 && {
			index: index + 1,
			item_list_name: 'vlp'
		}),
		quantity: 1
	}));
